import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import LibraryApiCall from 'LibraryApiCall';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import AdvanceFilterIcon from "LIBRARY/CommonResources/images/advanceFilterIcon.png";
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import filterIcon from 'LIBRARY/CommonResources/images/filterIcon.svg';


class DonorList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All donor data report List
            donorsListLoading: false,
            donorsListData: {},
            totalDonorItem: 0,
            pageIndex: 1,
            limit: "10",

            searchByDonorName: '',

            //filter button 
            showFilterModal: false,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Donor Name", isVisible: true },
                { name: 'Donor Email', isVisible: true },
                { name: 'Mobile Number', isVisible: true },
                { name: "Donor Address", isVisible: true },
                { name: "Donated Resources Count", isVisible: true }

            ],

            //STATE FOR header
            exportCSVHeaders: [
                { label: "Donor Name", key: 'donorName' },
                { label: 'Donor Email', key: 'donorEmail' },
                { label: 'Mobile Number', key: 'mobileNumber' },
                { label: "Donor Address", key: 'donorAddress' },
                { label: "Donated Resources Count", key: 'donatedResourceCount' }
            ],

            exportItemVisibility: [
                { name: "Donor Name", isVisible: true },
                { name: 'Donor Email', isVisible: true },
                { name: 'Mobile Number', isVisible: true },
                { name: "Donor Address", isVisible: true },
                { name: "Donated Resources Count", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],
        };
    }

    componentDidMount() {
        this.library_getDonorList();
        this.formatCSVExportData('onLoad');
    }

    //API CALL METHOD TO LIST OF DONOR LIST REPORT
    library_getDonorList = async () => {
        this.setState({
            donorsListLoading: true
        });

        let requestData = {
            'institute_id': config.institute_id,
            'page_index': this.state.pageIndex,
            'limit': this.state.limit,
            'filter_name': this.state.searchByDonorName,
            'filter_contact': "",
            'filter_email': "",
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getDonorList',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getDonorList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            donorsListData: apiResult.data,
                            totalDonorItem: apiResult.totalCount,
                            donorsListLoading: false
                        });
                    } else {
                        this.setState({
                            donorsListData: {},
                            totalDonorItem: 0,
                            donorsListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        donorsListData: {},
                        donorsListLoading: false
                    });
                }
            }
        }
    }

    // filter donor name on change
    handleDonorNameChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByDonorName: event.target.value });
    };

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByDonorName: this.state.searchByDonorName }, () => {
            this.library_getDonorList();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value, searchByDonorName: this.state.searchByDonorName }, () => {
            this.library_getDonorList();
        });
    }

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByDonorName: '', limit: "10", pageIndex: 1
        }
            , () => {
                this.library_getDonorList(); // report list
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterDonorName = this.state.searchByDonorName

        if (filterDonorName) {
            FilterArray.push(`Donor Name - ${filterDonorName}`)
        }
        return (
            <table className="table table-bordered" id="ExportAllDonorListData" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                Donor List
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Donor Name</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Donor Email</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Mobile Number</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Donor Address</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Donated Resources Count</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="12">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((donorData, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{donorData?.donorName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{donorData?.donorEmail || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{donorData?.donorContact || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{donorData?.donorAddress || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{donorData?.donatedResourcesCount || ""}</td>}

                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="12">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalDonorItem } = this.state;
        const totalPages = Math.ceil(totalDonorItem / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let requestData = {
                'institute_id': config.institute_id,
                'page_index': pageIndex,
                'limit': 50,
                'filter_name': this.state.searchByDonorName,
                'filter_contact': "",
                'filter_email': "",
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_getDonorList',
                requestData,
                '/api/library/library.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;

                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                    }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterDonorName = this.state.searchByDonorName

        if (filterDonorName) {
            FilterArray.push(`Donor Name - ${filterDonorName}`)
        }
        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        {/* header */}
                        <div className="d-flex col-md-12 px-0">
                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                {/* action button - filter */}
                                <div className="d-flex">
                                    <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() =>
                                        this.setState({
                                            showFilterModal: !this.state.showFilterModal
                                        })
                                    }><FontAwesomeIcon size='sm' icon={["fa", "filter"]} /> Filter</button>
                                </div>
                            </div>
                            {
                                Object.keys(this.state.donorsListData).length == 0 ? null :
                                    <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex align-items-center">
                                            {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="donorListReport"
                                                            filename="DonorListData"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="exportAll"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="ExportAllDonorListData"   // export all functionality
                                                            filename="ExportAllDonorListData"
                                                            sheet="tablexls"
                                                            buttonText="Export All to Excel"
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={this.formatCSVExportData}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                    {this.state.isExportAllReportDataFetching ? (
                                                        <p className="dropdown-item">
                                                            Exporting report . . .&nbsp;
                                                            <FontAwesomeIcon
                                                                icon={["fas", "circle-notch"]}
                                                                className="rotate"
                                                            />
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={() => this.setState({ allReportData: {} }, () => {
                                                                this.methodToExportReportData(0)
                                                            })}
                                                            className="dropdown-item"
                                                            title="Click to Export All"
                                                            style={{ boxShadow: 'none' }}
                                                        >
                                                            Export All
                                                        </button>
                                                    )}
                                                </span>

                                            </div>

                                        </div>

                                        {/* 2 action button - print */}
                                        <div className="d-flex ml-2" title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 3 action button - column visibility */}
                                        <div className="d-flex ml-2" title="Click to Customize Columns">
                                            <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                            {/* action modal - column visibility*/}
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                {/* id='settingDropdown' */}
                                                <div className='settingDropdown-body'>
                                                    {
                                                        this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                            return (
                                                                <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                    <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                    <input type="checkbox" checked={columnInfo.isVisible} />
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>

                        {/* filter fields */}
                        {this.state.showFilterModal &&
                            <div>
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div className="d-flex col-md-12" style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                                <div style={{ marginTop: '10px' }}>
                                                    {/* Based On Search by donor name */}
                                                    <div className="mb-2  p-1">
                                                        <label className="vm_custom_body3" color='#454E52'>Donor Name</label>
                                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                            <img
                                                                src={searchPng}
                                                                style={{
                                                                    position: 'absolute',
                                                                    left: '10px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    color: '#ccc',
                                                                    backgroundColor: 'white',
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    zIndex: 1,
                                                                }}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control formControlAutoTask"
                                                                id="searchByNameFilter"
                                                                placeholder="Search By Name"
                                                                title="Search By Name"
                                                                style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                value={this.state.searchByDonorName} // Bind value to state
                                                                onChange={this.handleDonorNameChange} // Handle input changes
                                                            // onKeyPress={this.handleStudentDetailsKeyPress} // Trigger API call on Enter
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                                <div style={{ marginTop: "10px" }}>
                                                    <button className="print-button btn outline-button" style={{ fontSize: '14px', borderRadius: '7px' }}
                                                        onClick={() => {
                                                            this.library_getDonorList()
                                                        }}
                                                    >
                                                        <style type="text/css" media="print">
                                                            {"@page { size: auto; }"}
                                                        </style>
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    (this.state.searchByDonorName !== '') &&
                                    <div className='filter-apply'>
                                        <p className='vm_custom_body5'>Filters are applied.</p>
                                        <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                    </div>
                                }
                            </div>
                        }

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Donor List</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="donorListReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        Donor List
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Donor Name</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Donor Email</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Mobile Number</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Donor Address</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Donated Resources Count</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.donorsListLoading ? <tr>
                                                    <td colSpan="12">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    Object.keys(this.state.donorsListData).length > 0 ?
                                                        (Object.values(this.state.donorsListData).map((donorData, index) => (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                {this.state.exportItemVisibilityForRows[0].isVisible && <td>{donorData?.donorName || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && <td>{donorData?.donorEmail || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && <td>{donorData?.donorContact || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[3].isVisible && <td>{donorData?.donorAddress || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <td>{donorData?.donatedResourcesCount || ""}</td>}

                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="12">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {
                                (Object.keys(this.state.donorsListData).length > 0 || Object.keys(this.state.donorsListData).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalDonorItem}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalDonorItem || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                </div>
            </div >

        );
    }
}


export default DonorList;